import { useMemo } from 'react';

import useAuthorizedUnits from '@/data/hook/shared/useAuthorizedUnits';

export default function useScopedUnits(unit?: number) {
  const { authorizedUnits, isAuthorizedUnit } = useAuthorizedUnits();

  return useMemo(
    () => (unit && isAuthorizedUnit(unit) ? [unit] : authorizedUnits),
    [unit, authorizedUnits, isAuthorizedUnit],
  );
}
